import styled from 'styled-components';

import { IconComponent } from './types';

/* Based on https://freesvg.org/circular-arrow-red */
const CircleArrowIcon: IconComponent = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      height="18"
      width="18"
      {...props}
    >
      <path
        fill="currentColor"
        d="m235 217 50 64c-106 83-160 217-139 350 32 202 222 340 423 308 202-32 340-222 308-423-15-98-68-184-148-242-70-51-153-75-238-70h1l70 73-52 49-159-167L518 0l49 52-75 71c102-5 202 25 286 86 97 71 161 175 180 294 39 245-130 477-375 515-24 4-47 6-70 6-218 0-410-159-445-381-26-162 39-325 169-426Z"
      />
    </svg>
  );
};

export const UndoIcon = styled(CircleArrowIcon)`
  transform: rotate(-90deg);
` as IconComponent;

export const RedoIcon = styled(CircleArrowIcon)`
  transform: scaleX(-1) rotate(-90deg);
` as IconComponent;
